import { Component, input, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormComponent } from '@shared/components';
import { NearGoalVideoComponent } from '@admin/components';
import { ACTION_LOADING } from '@admin/campaigns/constants/variables';
import { NearGoal, NearGoalVideo } from '@admin/models/NearGoal.model';
import { CustomInputNumberComponent } from '@admin/components/custom-input-number/custom-input-number.component';

@Component({
  selector: 'app-near-goal',
  imports: [
    FormsModule,
    DecimalPipe,
    NearGoalVideoComponent,
    CustomInputNumberComponent,
  ],
  templateUrl: './near-goal.component.html',
  styleUrl: './near-goal.component.scss',
})
export class NearGoalComponent extends FormComponent {
  @Input() override data: NearGoal = new NearGoal();
  typeId = input<number>(0);
  viewership = input<string>();

  ngOnInit(): void {
    this.endpoint = `admin/segments/broadcast/${this.data.id}`;
    this.method = 'put';

    if (this.data.matches.length === 0) {
      this.newMatch();
    }

    this.calculateCPMContrated();
    this.calculateTotal();
    this.data.init();
  }

  handleSubmit() {
    if (this.files.length > 0) {
      this.handleMedia().subscribe({
        next: (paths: string[]) => {
          let pIndex = 0;

          this.files.forEach((mathFile, index) => {
            mathFile.file.forEach((file, findex) => {
              if (file instanceof File && paths[pIndex]) {
                // left
                if (findex === 0) {
                  this.data.matches[index].leftMedia = paths[pIndex];
                } else {
                  this.data.matches[index].rightMedia = paths[pIndex];
                }

                pIndex++;
              }
            });
          });

          this.submit();
        },
        error: (error) => {
          this.handleAlert(error || 'An error occurred');
          this.stopLoading();
        },
      });
    } else {
      this.submit();
    }
  }

  newMatch() {
    const nVideo = new NearGoalVideo();

    this.data.matches.push(nVideo);

    setTimeout(() => {
      const element = document.getElementById(
        `match-${this.data.matches.length}`
      );

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, ACTION_LOADING - 80);
  }

  deleteMatch(index: number) {
    this.data.matches.splice(index, 1);
  }

  override isValid(): boolean {
    this.data.matches = this.data.matches.filter((match) => {
      if (
        match.leftMedia === '' ||
        match.rightMedia === '' ||
        match.game === ''
      ) {
        return false;
      }

      return true;
    });

    const valid = this.data.matches.length > 0;

    if (!valid) {
      this.handleAlert('Match is required');
      this.newMatch();
    }

    return valid;
  }

  override getParams() {
    const params = {
      impressions: this.data.summary.impressionsContracted,
      items: this.data.matches,
    };

    return params;
  }

  override success(response: any): void {
    this.handleAlert(`¡Changes saved successfully!`, 'success');

    this.stopLoading();
  }

  calculateTotal() {
    this.data.calculateSummary();
    this.data.calculateCPMDelivered();
  }

  calculateCPMContrated() {
    this.data.calculateCPMContrated();
  }
}
